import { UserPageApi } from './UserPageApi';
import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';
import { CasUserResponse } from './types';
import { ResponseError } from './ResponseError';

export class UserPageClient implements UserPageApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;
  }) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  async getCasUserAndAppliances(url: string): Promise<CasUserResponse> {
    const response = await this.get(url);
    return {
      body: response.body,
      status: response.status,
    };
  }

  async get(path: string): Promise<any> {
    const url = `${await this.discoveryApi.getBaseUrl('proxy')}${path}`;
    const { token: idToken } = await this.identityApi.getCredentials();
    const response = await fetch(url, {
      headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
    });

    if (!response.ok) {
      const body = response;
      const message = `Request failed with ${response.status} ${response.statusText}, ${body}`;
      throw new ResponseError(message, response);
    }

    const body = await response.json();
    return { status: response.status, body };
  }
}
